import _ from 'lodash'

// Extiende el componente con los hooks especificados
// En la definion de un hook se ha de especificar el nombre del hook y el data con el que trabajaran
// @comp Componente a extender
// @hooks Array que contiene lugar del hook y callback
// @returns Nuevo componente con hooks aplicados
export default (comp, hooks, config) => {

	let newComp = _.cloneDeep(comp)

	if (config) newComp = _.merge(newComp, config)

	if (!newComp.methods) newComp.methods = {}

	newComp.methods.$_callHook = async function (hook, data) {

		let output = _.cloneDeep(data)

		const filteredHooks = hooks.filter(h => h.hook === hook)

		for (const h of filteredHooks) {

			const out = await h.callback(this, output)

			if (out) output = out

		}

		return output

	}

	return newComp

}
